import React from 'react';
import PropTypes from 'prop-types';

const ScrapeShieldSettingsSublist = ({settings}) => {
    const vulnerableSettingsExist = () => {
        if (settings.email_obfuscation !== 'on' ||
        settings.server_side_exclude !== 'on' ||
        settings.hotlink_protection !== 'on') {
            return true;
        }

        return false;
    };

    return vulnerableSettingsExist() &&
        <fieldset className='rounded fieldset margin-bottom-2'>
            <legend className='lead font-bold'>Scrape Shield Settings</legend>
            <table className='margin-0'>
                <thead>
                    <tr>
                        <th>Config</th>
                        <th style={{width: '33%'}}>Current Value</th>
                        <th style={{width: '33%'}}>Recommended Value</th>
                    </tr>
                </thead>
                <tbody>
                    {settings.email_obfuscation !== 'on' &&
                    <tr>
                        <td>Email Address Obfuscation</td>
                        <td className='alert-color'>{settings.email_obfuscation}</td>
                        <td>on</td>
                    </tr>}
                    {settings.server_side_exclude !== 'on' &&
                    <tr>
                        <td>Server-side Excludes</td>
                        <td className='alert-color'>{settings.server_side_exclude}</td>
                        <td>on</td>
                    </tr>}
                    {settings.hotlink_protection !== 'on' &&
                    <tr>
                        <td>Hotlink Protection</td>
                        <td className='alert-color'>{settings.hotlink_protection}</td>
                        <td>on</td>
                    </tr>}
                </tbody>
            </table>
        </fieldset>;
};

ScrapeShieldSettingsSublist.propTypes = {
    settings: PropTypes.object.isRequired
};

export default ScrapeShieldSettingsSublist;